import React, { useEffect } from 'react'

import { alertsSection, isPriceChangeTabLoading } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import PriceChangeTable from "Pages/ReportsAlerts/Alerts/Conditions/PriceChange/Table"
import PriceChangeDrawer from "Pages/ReportsAlerts/Alerts/Conditions/PriceChange/Drawer"
import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { isTourDemoActive } from "@signals/app"


export default function PriceChangeBlock() {

	const {
		getTableData,
		tableData,
		isTableLoading,
		onDeleteAlert,
		onEditAlert,
		onSubmitAlert,
		isAlertSubmitting,
		filterConditions,
	} = useAlertsTableData(`${BACKEND_APIS.CONDITIONS}/price-change`)

	useEffect(() => {
		isPriceChangeTabLoading.value = true
		getTableData()
			.then(() => isPriceChangeTabLoading.value = false)
			.catch(() => isPriceChangeTabLoading.value = false)
	}, [])

	if (alertsSection.value !== ALERTS.PRICE_CHANGE) return <></>

	return <>
		{!(isTourDemoActive.value && !tableData?.length) && <PriceChangeTable
			data={tableData}
			isLoading={isTableLoading}
			onDeleteAlert={onDeleteAlert}
			onEditAlert={onEditAlert}
			filterConditions={filterConditions}
		/>}
		<PriceChangeDrawer onSubmitAlert={onSubmitAlert} isLoading={isAlertSubmitting}/>
	</>
}